import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M11.4 1.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L20.9 12 10.7 22.2c-.2.2-.2.5 0 .7.2.2.5.2.7 0 0 0 0 0 0 0l10.5-10.5c.2-.2.2-.5 0-.7L11.4 1.1z"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M13.3 11.7 2.8 1.1c-.2-.1-.5-.1-.7.1-.2.2-.2.5 0 .7L12.3 12 2.1 22.2c-.2.2-.2.5 0 .7.2.2.5.2.7 0 0 0 0 0 0 0l10.5-10.5c.2-.3.2-.6 0-.7z"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M11 23c-.3 0-.5-.2-.5-.5 0-.1.1-.2.1-.3L20.9 12 10.7 1.8c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l10.5 10.5c.2.2.2.5 0 .7L11.4 22.9c-.1 0-.2.1-.4.1z"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M2.4 23c-.2 0-.4-.2-.4-.5 0-.1.1-.2.1-.3L12.3 12 2.1 1.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l10.5 10.5c.2.2.2.5 0 .7L2.8 22.9c-.1 0-.2.1-.4.1z"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }